export default __webpack_public_path__ + "static/media/banefulvenom.b83af415.png";